import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CUSTOMER_JOURNEY_URL } from "../data/constants";
import { SEO } from "../components/SEO";

const STEPS = [
  { num: "01", title: "Setup & Audit", desc: "We analyze your current digital presence and identify opportunities" },
  { num: "02", title: "Launch Visibility", desc: "Implement SEO, ads, DSP campaigns, and listing sync to get you found" },
  { num: "03", title: "Conversion Layer", desc: "Deploy AI conversations and lead capture forms" },
  { num: "04", title: "Retention & Automation", desc: "Set up review requests, campaigns, and nurture sequences" },
  { num: "05", title: "Monthly Optimization", desc: "Continuous reporting and strategy refinement" }
];

const CustomerJourneyPage = () => {
  const navigate = useNavigate();
  return (
    <div className="pt-20" data-testid="customer-journey-page">
      <SEO
        title="Customer Journey Framework"
        description="Our proven full-funnel system to attract, convert, and retain customers — Setup, Visibility, Conversion, Retention, and Monthly Optimization."
        path="/customer-journey"
      />
      <section className="section-padding bg-gradient-to-br from-orange-light via-white to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="font-display text-4xl md:text-5xl font-bold text-gray-dark mb-4">Customer Journey Framework</h1>
            <p className="text-gray-medium text-lg max-w-2xl mx-auto">
              Our proven full-funnel system to attract, convert, and retain customers
            </p>
          </div>

          <div className="flex justify-center mb-16">
            <img src={CUSTOMER_JOURNEY_URL} alt="Customer Journey Framework" className="max-w-full lg:max-w-4xl rounded-2xl shadow-card-hover" data-testid="journey-image-large" />
          </div>

          <div className="mb-16">
            <h2 className="font-display text-2xl font-bold text-gray-dark text-center mb-8">How We Implement This</h2>
            <div className="space-y-4">
              {STEPS.map((step, idx) => (
                <div key={idx} className="bg-white p-6 rounded-xl shadow-card flex items-start gap-6 card-hover">
                  <span className="text-4xl font-display font-bold text-orange-primary">{step.num}</span>
                  <div>
                    <h3 className="font-display font-bold text-lg text-gray-dark mb-1">{step.title}</h3>
                    <p className="text-gray-medium">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center">
            <button onClick={() => navigate("/store")} className="btn-primary text-lg" data-testid="journey-start-btn">
              Start Now <ArrowRight size={20} className="inline ml-2" />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CustomerJourneyPage;
